/**
 * Assigns a new URL to the window.location object.
 *
 * Use this action for navigating to projects outside of AD.
 * For navigating within AD, use NavigateTo or NavigateToUrl.
 */
export default class AssignWindowLocation {
  constructor(context) {
    this.context = context;
  }

  run(url) {
    window.location.assign(url);
  }
}
